export default __webpack_public_path__ + "static/media/2006.bc8129b3.png";